module.exports = __webpack_public_path__ + "static/img/icon-level-01.314281cb.svg";